<app-page-header
  title="Feedback abgeben"
  subtitle="Teile uns deine Erfahrungen, Ideen oder Wünsche mit."
  icon="rate_review"
  variant="gradient">
</app-page-header>

<div class="nlc-container nlc-feedback-wrapper nlc-slide-up">
  <div class="nlc-feedback-grid">
    <div class="nlc-card nlc-feedback-card">
      <form class="nlc-feedback-form" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="nlc-feedback-field" floatLabel="always">
          <mat-label>Deine Nachricht</mat-label>
          <textarea
            matInput
            rows="5"
            placeholder="Teile deine Erfahrungen, Ideen oder Wünsche..."
            [(ngModel)]="feedbackText"
            name="feedbackText"
          ></textarea>
        </mat-form-field>

        <div class="nlc-feedback-rating">
          <span class="nlc-feedback-rating-label">Bewertung</span>
          <div class="nlc-feedback-stars">
            <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
              <button
                type="button"
                class="nlc-rating-star"
                [class.filled]="rating.value >= i + 1"
                (click)="setRating(i + 1)"
                [attr.aria-label]="'Bewertung ' + (i + 1)"
              >
                <mat-icon>{{ rating.value >= i + 1 ? 'star' : 'star_border' }}</mat-icon>
              </button>
            </ng-container>
            <button
              type="button"
              class="nlc-rating-clear"
              (click)="setRating(0)"
              [disabled]="rating.value === 0"
              [attr.aria-label]="'Bewertung zurücksetzen'"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div class="nlc-feedback-actions">
          <button
            mat-flat-button
            color="primary"
            class="nlc-button nlc-button-primary nlc-button-large"
            type="submit"
            [disabled]="!feedbackText && rating.value === 0"
          >
            <mat-icon>send</mat-icon>
            Absenden
          </button>
        </div>
      </form>
    </div>

    <aside class="nlc-feedback-aside nlc-card">
      <div class="aside-icon">
        <mat-icon>emoji_objects</mat-icon>
      </div>
      <h2 class="nlc-heading-3">Warum Feedback wichtig ist</h2>
      <p class="nlc-body-secondary">
        Dein Feedback hilft uns, Funktionen zu priorisieren und die Plattform kontinuierlich zu
        verbessern. Jede Rückmeldung wird gelesen und fließt in unsere Roadmap ein.
      </p>
      <ul class="nlc-feedback-hints">
        <li>Sei konkret: Was hat dir gefallen oder gefehlt?</li>
        <li>Welche Schritte waren besonders hilfreich oder kompliziert?</li>
        <li>Gibt es Funktionen, die du dir wünschst?</li>
      </ul>
      <p class="nlc-caption">
        Wir antworten dir per E‑Mail, wenn wir Rückfragen haben oder etwas umgesetzt wurde.
      </p>
    </aside>
  </div>
</div>
